export const MONEY_GUID_PRO = 'MONEY_GUID_PRO';
export const clearCache = `${MONEY_GUID_PRO}-CLEAR-CACHE`;
export const summaryReducerPrefix = `${MONEY_GUID_PRO}-SUMMARY`;
export const insuranceReducerPrefix = `${MONEY_GUID_PRO}-INSURANCE`;
export const goalsReducerPrefix = `${MONEY_GUID_PRO}-GOALS`;
export const netWorthReducerPrefix = `${MONEY_GUID_PRO}-NET_WORTH`;
export const refreshPrefix = `${MONEY_GUID_PRO}-REFRESH`;

export const refreshEndpointKeyMap = {
  Summary: 'summary',
  Goals: 'goals',
  Insurance: 'insurance',
  NetWorth: 'netWorth',
};
